import moment, { duration } from 'moment';
import { resource_images } from 'Utils/options';
import ResourceBirth from 'Assets/img/resources/Resource-Icons-Birth-transparent.png';
import ResourceIcon1to2 from 'Assets/img/resources/Resource-Icons-1to2-transparent.png';
import ResourceIcons2to3 from 'Assets/img/resources/Resource-Icons-2to3-transparent.png';
import ResourceIcon3to4Transparent  from 'Assets/img/resources/Resource-Icons-3to4-text-transparent.png';
import ResourceCategoryGrossMotor from 'Assets/img/resources/Resource-Icons-Gross-Motor-transparent.png';
import ResourceIconFineMotor from 'Assets/img/resources/Resource-Icons-Fine-Motor-transparent.png';
import ResourceIconCognitive from 'Assets/img/resources/Resource-Icons-Cognitive-transparent.png';
import ResourceIconSocialEmotion from 'Assets/img/resources/Resource-Icons-Social-Emotional-transparent.png'
import ResourceIconSensory from 'Assets/img/resources/Resource-Icons-Sensory-transparent.png';
import ResourceIconLanguage from 'Assets/img/resources/Resource-Icons-Language-transparent.png';
import ResourceIconChildDevelopment from 'Assets/img/resources/Resource-Icons-Child-Development-transparent.png'
import ResourceIconDevelopmentChallenges from 'Assets/img/resources/Resource-Icons-Developmental-Challenges-transparent.png';
import ResourceIconGiftedChildren from 'Assets/img/resources/Resource-Icons-Gifted-Children-transparent.png';
import ResourceIconSelfCare from 'Assets/img/resources/Resource-Icons-Self-Care-Parents-transparent.png';

import CategoryGrossMotor from 'Assets/img/category/Category-Gross-Motor-transparent.png'
import CategoryFineMotor from 'Assets/img/category/Category-Fine-Motor-transparent.png'
import CategoryCognitive from 'Assets/img/category/Category-Cognitive-transparent.png'
import CategorySocialEmotional from 'Assets/img/category/Category-Social-Emotional-transparent.png'
import CategorySensory from 'Assets/img/category/Category-Sensory-transparent.png'
import CategoryLanguage from 'Assets/img/category/Category-Language-transparent.png'


import DjecoBabyPopi from 'Assets/img/Activities/Djeco-Baby-Popi-1.jpg'
import Wigloo from 'Assets/img/Activities/wigloo-6.jpg'
import TeguSwivel from 'Assets/img/Activities/Tegu-swivel-bug-2.jpg'
import DjecoBigabasic from 'Assets/img/Activities/Djeco-Bigabasic-2.jpg'
import HapeBumblebeeChain from 'Assets/img/Activities/Hape-Bumblebee-Pram-Chain-1.jpg'
import HapeBumblebeeRattle from 'Assets/img/Activities/Hape-Bumblebee-pram-rattle_2.jpg'
import HapeSpring from 'Assets/img/Activities/Hape-springaling-2.jpg'
import MolukBoi from 'Assets/img/Activities/Moluk-Boi-2.jpg'
import MushieForestStacking from 'Assets/img/Activities/Mushie-ForestStackingCups-6.jpg'
import NogginRings from 'Assets/img/Activities/Noggin-Rings-1.jpg'
import Zippie from 'Assets/img/Activities/zippee-8.jpg'
import DjecoOski from 'Assets/img/Activities/Djeco-Oski-1.jpg'
import AnimalFriends from 'Assets/img/Activities/1-2-17-019-Animal-Friends-3.png'
import BabaiFishing from 'Assets/img/Activities/Babai-fishing-game-1.jpg'
import Clementoni from 'Assets/img/Activities/Clementoni-little-puzzle-vehicles-1.jpg'
import DjecoBigAnimals from 'Assets/img/Activities/Djeco-Biganimals-1.jpg'
import HabaCuddyFoxie from 'Assets/img/Activities/Haba-Cuddy-Foxie-1.jpg'
import HapeBugMaze from 'Assets/img/Activities/Hape-Bug-Maze-1.jpg'
import HapeTurtleMaze2 from 'Assets/img/Activities/hape-turtle-maze-2.jpg'
import JanodFoxStacker1 from 'Assets/img/Activities/Janod-fox-stacker-1.jpg'
import JanodGear1 from 'Assets/img/Activities/Janod-gear-1.png'
import JanodGeometicShapes from 'Assets/img/Activities/janod-geometric-shapes-3.jpg'
import JanodStackableBear from 'Assets/img/Activities/Janod-stackable-bear-1.jpg'
import JanodTap from 'Assets/img/Activities/Janod-tap-tap-xylophone-wood.jpg'
import JungleMaze from 'Assets/img/Activities/jungle-maze-1.jpg'
import LondjiOceanMemory from 'Assets/img/Activities/Londji-ocean-memory-game-2.jpg'
import ManhattanWhoosit from 'Assets/img/Activities/Manhattan-Whoosit-Water-Mat-1.jpg'
import PlayzoneFitWack from 'Assets/img/Activities/playzone-fit-Wack-a-tag-1.jpg'
import PlayZoneFirWacka2 from 'Assets/img/Activities/Playzone-fit-Wack-a-tag-2.jpg'
import PolyMZooKeeper from 'Assets/img/Activities/PolyM-Zoo-keeper-2.jpg'
import DamScratchStarter from 'Assets/img/Activities/dam-scratch-starter-puzzle-ocean-1.jpg'
import DIYTissueBox from 'Assets/img/Activities/DIY-Tissue-Box.jpg'
import DjecoBabyShaking from 'Assets/img/Activities/Djeco-Baby-Shaki-1.jpg'
import DjecoClipaClip from 'Assets/img/Activities/Djeco-Clipaclip-1.jpg'
import FlenstedMemorabil from 'Assets/img/Activities/Flensted-memorabilia-mobile-2.jpg'
import HapeAlphabetPeg from 'Assets/img/Activities/Hape-alphabet-peg-puzzle.jpg'
import LearnToCount from 'Assets/img/Activities/i-learn-to-count-puzzle-4.jpg'
import JanodEssentialFracture from 'Assets/img/Activities/janod-essential-fractions.jpg'
import MagnatabLowercase from 'Assets/img/Activities/magnatab-lowercase.jpg'
import MiniJournalQua from 'Assets/img/Activities/MINI-journal-aqua.jpg'
import PlayZoneFit1 from 'Assets/img/Activities/Playzone-fit-1.png'
import PuzzleStickDinno from 'Assets/img/Activities/Puzzle-Sticks-Dino.jpg'
import Woblii from 'Assets/img/Activities/Woblii-2.jpg'


export const yearCalculator = (birthday: any) => {
	const years = moment().diff(birthday, 'years');
	const months = moment().diff(birthday, 'months');
	return `${years === 0 ? '' : years} ${years === 0 ? '' : Math.floor(months/12) > 1 ? 'Years' : 'Year'} ${
		months === 0 ? '' : months % 12
	} ${months === 0 ? '' : months % 12 > 1 ? 'Months' : 'Month'} `;
};

export const yearCalculatorToMonths = (birthDate:any) => {
	const years = moment().diff(birthDate,'years');
	const months = moment().diff(birthDate,'months');

	return months;
}



export const formatDate = (value:any) => {
	const today = moment;
	if (value =='Last week' ){

		return moment().subtract(7,'d').format('YYYY-MM-DD');
	} else if ( value =='2 weeks ago' ){

		return moment().subtract(14,'d').format('YYYY-MM-DD');
	} else if ( value =='3 weeks ago' ){

		return moment().subtract(21,'d').format('YYYY-MM-DD');
	} else if ( value =='1 month ago' ){

		return moment().subtract(30,'d').format('YYYY-MM-DD');
	} else if ( value =='1 and a half month ago' ){

		return moment().subtract(45,'d').format('YYYY-MM-DD');
	} else if ( value =='2 months ago' ){

		return moment().subtract(60,'d').format('YYYY-MM-DD');
	} else if ( value =='3 months ago' ){

		return moment().subtract(90,'d').format('YYYY-MM-DD');
	} else if ( value == '4 months ago' ){

		return moment().subtract(120,'d').format('YYYY-MM-DD');
	} else if ( value == 'This week' ){

		return moment().subtract(1,'d').format('YYYY-MM-DD');
	}
}
export const minuteConversion = (time: any) => {

	// return moment.duration(time, 'minutes').minutes();
	return time;
};

export const changeIdentities = (text: any, name?: any, gender?: any) => {
	return text
		.replaceAll(`{NAME}`, name)
		.replaceAll(`[child's name]`, name)
		.replaceAll(`{he/she}`, gender === 'MALE' ? 'he' : 'she')
		.replaceAll(`{HIMSELFHERSELF}`,gender === 'MALE' ? 'himself' : 'herself')
		.replaceAll(`[he/she]`, gender === 'MALE' ? 'he' : 'she')
		.replaceAll(`{him/her}`, gender === 'MALE' ? 'him' : 'her')
		.replaceAll(`{HERHIM}`, gender === 'MALE' ? 'him' : 'her')
		.replaceAll(`{HISHER}`, gender === 'MALE' ? 'his' : 'her')
		.replaceAll(`{HESHE}`, gender === 'MALE' ? 'he' : 'she');
};

export const shuffleItems = (items: string[]) => items[Math.floor(Math.random() * items.length)];

export const shuffleCategories = (items: any) => items[Math.floor(Math.random() * items.length)].backgroundImage;
export const shuffleAchieved = (items: any) => items[Math.floor(Math.random() * items.length)].achievedbudge;
export const shuffleNotAchieved = (items: any) => items[Math.floor(Math.random() * items.length)].budge;

export const goToLink = (text: any, no: number) =>
	//
	{
		if (text.length > no) {
			const newText = text.substring(0, no);
			return { newText, read: 'Read more...' };
		}
		return {newText:text,read: 'Read more...'};
	};

export const findMatch = (arraySmall: any, arrayLarge: any) => {
	const res = [];
	for (let i = 0; i < arrayLarge.length; i++) {
		for (let j = 0; j < arraySmall.length; j++) {
			if (arrayLarge[i] === arraySmall[j]) {
				res.push(i);
			}
		}
	}
	return res;
};


export const checkImage = (imageName:any) => {
	return imageName.split('https://www.fledglingsflight.com/assets/resources/')[1]
};

export const setImage = (image: any) => {
	const imageName = checkImage(image);
	switch (imageName) {
		case 'Resource-Icons-Birth-transparent.png':
			return ResourceBirth
		case 'Resource-Icons-1to2-transparent.png':
			return ResourceIcon1to2
		case 'Resource-Icons-2to3-transparent.png':
			return ResourceIcons2to3
		case 'Resource-Icons-3to4-text-transparent.png':
			return ResourceIcon3to4Transparent
		case 'Resource-Icons-Gross-Motor-transparent.png':
			return ResourceCategoryGrossMotor
		case 'Resource-Icons-Fine-Motor-transparent.png':
			return ResourceIconFineMotor
		case 'Resource-Icons-Cognitive-transparent.png':
			return ResourceIconCognitive
		case 'Resource-Icons-Social-Emotional-transparent.png':
			return ResourceIconSocialEmotion
		case 'Resource-Icons-Sensory-transparent.png':
			return ResourceIconSensory
		case 'Resource-Icons-Language-transparent.png':
			return ResourceIconLanguage
		case 'Resource-Icons-Child-Development-transparent.png':
			return ResourceIconChildDevelopment
		case 'Resource-Icons-Gifted-Children-transparent.png':
			return ResourceIconGiftedChildren
		case 'Resource-Icons-Developmental-Challenges-transparent.png':
			return ResourceIconDevelopmentChallenges
		case 'Resource-Icons-Self-Care-Parents-transparent.png':
			return ResourceIconSelfCare
		default:
			return ResourceIconGiftedChildren
	}
};


export const checkImageCategory = (imageName:any) => {
	const imageUrl = 'https://www.fledglingsflight.com/assets/category/';
	const imageSplit = imageName.split(imageUrl)[0];
	if (imageSplit    === ""){
		return imageName.split(imageUrl)[1]
	}
	return imageName
};
export const setExerciseImage = (imageName:any) => {
	const image = checkImageCategory(imageName);
	switch(image){
		case "Category-Gross-Motor-transparent.png":
			return CategoryGrossMotor;
		case "Category-Fine-Motor-transparent.png":
			return CategoryFineMotor;
		case "Category-Cognitive-transparent.png":
			return CategoryCognitive
		case "Category-Social-Emotional-transparent.png":
			return CategorySocialEmotional
		case "Category-Sensory-transparent.png":
			return CategorySensory
		case "Category-Language-transparent.png":
			return CategoryLanguage
		default:
			return image;
	}

}


export const checkActivitiesImage = (image:any) => {
	return image.split('https://www.fledglingsflight.com/assets/Activities/')[1]
}



export const setActivitiesImage = (image:any) => {
	const imageName = checkActivitiesImage(image);
	// eslint-disable-next-line no-console
	console.log("the image is",imageName)
	switch(imageName){
		case "wigloo-6.jpg":
			return Wigloo
		case "Tegu-swivel-bug-2.jpg":
			return TeguSwivel
		case "Djeco-Bigabasic-2.jpg":
			return DjecoBigabasic
		case "Hape-Bumblebee-Pram-Chain-1.jpg":
			return HapeBumblebeeChain
		case "Hape-Bumblebee-pram-rattle_2.jpg":
			return HapeBumblebeeRattle
		case "Hape-springaling-2.jpg":
			return HapeSpring
		case "Moluk-Boi-2.jpg":
			return MolukBoi
		case "Mushie-ForestStackingCups-6.jpg":
			return MushieForestStacking
		case "Noggin-Rings-1.jpg":
			return NogginRings
		case "zippee-8.jpg":
			return Zippie
		case "Djeco-Oski-1.jpg":
			return DjecoOski
		case "1-2-17-019-Animal-Friends-3.png":
			return AnimalFriends
		case "Babai-fishing-game-1.jpg":
			return BabaiFishing
		case "Clementoni-little-puzzle-vehicles-1.jpg":
			return Clementoni
		case "Djeco-Biganimals-1.jpg":
			return DjecoBigAnimals
		case "Haba-Cuddy-Foxie-1.jpg":
			return HabaCuddyFoxie
		case "Hape-Bug-Maze-1.jpg":
			return HapeBugMaze
		case "hape-turtle-maze-2.jpg":
			return HapeTurtleMaze2
		case "Janod-fox-stacker-1.jpg":
			return JanodFoxStacker1
		case "Janod-gear-1.png":
			return JanodGear1
		case "janod-geometric-shapes-3.jpg":
			return JanodGeometicShapes
		case "Janod-stackable-bear-1.jpg":
			return JanodStackableBear
		case "Janod-tap-tap-xylophone-wood.jpg":
			return JanodTap
		case "jungle-maze-1.jpg":
			return JungleMaze
		case "Londji-ocean-memory-game-2.jpg":
			return LondjiOceanMemory
		case "Manhattan-Whoosit-Water-Mat-1.jpg":
			return ManhattanWhoosit
		case "playzone-fit-Wack-a-tag-1.jpg":
			return PlayzoneFitWack
		case "playzone-fit-Wack-a-tag-2.jpg":
			// eslint-disable-next-line no-console
			console.log("here")
			return PlayZoneFirWacka2
		case "PolyM-Zoo-keeper-2.jpg":
			return PolyMZooKeeper
		case "dam-scratch-starter-puzzle-ocean-1.jpg":
			return DamScratchStarter
		case "DIY-Tissue-Box.jpg":
			return DIYTissueBox
		case "Djeco-Baby-Shaki-1.jpg":
			return DjecoBabyShaking
		case "Djeco-Clipaclip-1.jpg":
			return DjecoClipaClip
		case "Flensted-memorabilia-mobile-2.jpg":
			return FlenstedMemorabil
		case "Hape-alphabet-peg-puzzle.jpg":
			return HapeAlphabetPeg
		case "i-learn-to-count-puzzle-4.jpg":
			return LearnToCount
		case "janod-essential-fractions.jpg":
			return JanodEssentialFracture
		case "magnatab-lowercase.jpg":
			return MagnatabLowercase
		case "MINI-journal-aqua.jpg":
			return MiniJournalQua
		case "Playzone-fit-1.png":
			return PlayZoneFit1
		case "Puzzle-Sticks-Dino.jpg":
			return PuzzleStickDinno
		case "Woblii-2.jpg":
			return Woblii 
		case "Djeco-Baby-Popi-1.jpg":
			return DjecoBabyPopi
	}
}
export const appendScript = (scriptToAppend: any )=> {
	const script = document.createElement('script');
	script.src = scriptToAppend;
	script.async = true;
	script.type = 'text/javascript';
	document.body.appendChild(script);
};



export const getMilestoneAchievedList = (birthday:any) => {

	const years = moment().diff(birthday, 'years');
	const months = moment().diff(birthday, 'months');
	const weeksDiff = moment().diff(birthday,'weeks')

	if ( weeksDiff === 0){

		return [
			{
				id: 0, name: 'This week' 
			},
		]
	} else if (weeksDiff === 1) {
		return [
			{ id: 0, name: 'This week' },
			{ id: 1, name: 'Last week' },
		]
	} else if (weeksDiff === 2 ){
		return [
			{ id: 0, name: 'This week' },
			{ id: 1, name: 'Last week' },
			{ id: 2, name: '2 weeks ago' },
		]
	} else if (weeksDiff === 3){
		return [
			{ id: 0, name: 'This week' },
			{ id: 1, name: 'Last week' },
			{ id: 2, name: '2 weeks ago' },
			{ id: 3, name: '3 weeks ago' },
		]
	} else if(weeksDiff > 1 &&  months === 1){
		return [
			{ id: 0, name: 'This week' },
			{ id: 1, name: 'Last week' },
			{ id: 2, name: '2 weeks ago' },
			{ id: 3, name: '3 weeks ago' },
			{ id: 4, name: '1 month ago' },
		]
	} else if(weeksDiff> 1 && months === 2){
		return [
			{ id: 0, name: 'This week' },
			{ id: 1, name: 'Last week' },
			{ id: 2, name: '2 weeks ago' },
			{ id: 3, name: '3 weeks ago' },
			{ id: 4, name: '1 month ago' },
			{ id: 5, name: '1 and a half month ago' },
			{ id: 6, name: '2 months ago' },
		]
	} else if(weeksDiff > 1 && months === 3 ){
		return [
			{ id: 0, name: 'This week' },
			{ id: 1, name: 'Last week' },
			{ id: 2, name: '2 weeks ago' },
			{ id: 3, name: '3 weeks ago' },
			{ id: 4, name: '1 month ago' },
			{ id: 5, name: '1 and a half month ago' },
			{ id: 6, name: '2 months ago' },
			{ id: 7, name: '3 months ago' },
		]
	} else if (weeksDiff>1 && months >= 4){
		return [
			{ id: 0, name: 'This week' },
			{ id: 1, name: 'Last week' },
			{ id: 2, name: '2 weeks ago' },
			{ id: 3, name: '3 weeks ago' },
			{ id: 4, name: '1 month ago' },
			{ id: 5, name: '1 and a half month ago' },
			{ id: 6, name: '2 months ago' },
			{ id: 7, name: '3 months ago' },
			{ id: 8, name: '4 months ago' }
		]
	}
}

import fineMotorIcon from 'Assets/img/svg/Backgrounds/fineMotor/fineMotorIcon.svg';
import cognitiveIcon from 'Assets/img/svg/Backgrounds/cognitive/cognitiveIcon.svg';
import communicationIcon from 'Assets/img/svg/Backgrounds/communication/communicationIcon.svg';
import grossMotorIcon from 'Assets/img/svg/Backgrounds/grossMotor/grossMotorIcon.svg';
import sensoryIcon from 'Assets/img/svg/Backgrounds/sensory/sensoryIcon.svg';

import fineMotorTopIcon from 'Assets/img/svg/Backgrounds/fineMotor/topIcon.svg';
import cognitiveTopIcon from 'Assets/img/svg/Backgrounds/cognitive/topIcon.svg';
import communicationTopIcon from 'Assets/img/svg/Backgrounds/communication/topIcon.svg';
import grossMotorTopIcon from 'Assets/img/svg/Backgrounds/grossMotor/topIcon.svg';
import sensoryIconTopIcon from 'Assets/img/svg/Backgrounds/sensory/topIcon.svg';


import socialEmotionalIcon from 'Assets/img/svg/Backgrounds/socialEmotional/socialEmotionalIcon.svg';
import socialEmotionalTopIcon from 'Assets/img/svg/Backgrounds/socialEmotional/topIcon.svg';

export const getMilestoneImage = (title:any,matches:any) => {

	switch(title){
		case "Gross motor skills":
			return matches ? grossMotorIcon : grossMotorTopIcon
		case "Fine motor skills":
			return matches ? fineMotorIcon : fineMotorTopIcon
		case "Fine motor skills":
			return matches ? fineMotorIcon : fineMotorTopIcon
		case "Social emotional":
			return matches ?  socialEmotionalIcon : socialEmotionalTopIcon
		case "Sensory":
			return matches ? sensoryIcon : sensoryIconTopIcon
		case "Communication":
			return matches ?  communicationIcon : communicationTopIcon
		default:
			return matches ? cognitiveIcon : cognitiveTopIcon
	}
}
